import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UdfFieldIdInterceptor implements HttpInterceptor {

  private readonly UDF_ORDER: string[] = [
    'U_HCO_ID',
    'U_PAciente',
    'U_Fecha',
    'U_Doctor',
    'U_OrdenCompra',
    'U_TContrato',
    'U_Hgasto',
    'U_FECHA_SIGES',
    'U_Instrumentista',
    'U_Instr',
    'U_Cirugia',
    'U_Cirurgia',
    'U_NContrato'
  ];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.method !== 'GET' || !request.url.includes('api/Udfs') || !request.url.includes('Configured=true')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body?.Data && Array.isArray(event.body.Data)) {
          const sortedData = this.sortUdfs(event.body.Data);
          return event.clone({ body: { ...event.body, Data: sortedData } });
        }
        return event;
      })
    );
  }

  private sortUdfs(udfs: any[]): any[] {
    return udfs.sort((a, b) => {
      const indexA = this.UDF_ORDER.indexOf(a.Name);
      const indexB = this.UDF_ORDER.indexOf(b.Name);
      const orderA = indexA === -1 ? 999 : indexA;
      const orderB = indexB === -1 ? 999 : indexB;
      return orderA - orderB;
    });
  }
}
